/**
* package: com.inq.flash.client.control.messagehandlers
* class: ChatAutomatonDataMessageHandler
* @extends com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler
* @constructor
*/
com.inq.flash.client.control.messagehandlers.ChatAutomatonDataMessageHandler = function() {
	com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler.call(this, com.inq.flash.client.data.MessageFields.TYPE_CHAT_AUTOMATON_DATA);
};

$hxClasses.extend(com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler,
	com.inq.flash.client.control.messagehandlers.ChatAutomatonDataMessageHandler,
	"com.inq.flash.client.control.messagehandlers.ChatAutomatonDataMessageHandler"
);


com.inq.flash.client.control.messagehandlers.ChatAutomatonDataMessageHandler.prototype.processMessage = function(message) {
	message.setMessageType(com.inq.flash.client.data.MessageFields.TYPE_CHAT_AUTOMATON_DATA);
	var textToDisplay = message.getProperty("messageText");
	var displayText = StringTools.trim(textToDisplay);
	var position = -1;
	var messageTimestamp = message.getPropertyAsDate(com.inq.flash.client.data.MessageFields.KEY_MESSAGE_TIMESTAMP);
	if (message.getProperty(com.inq.flash.client.data.MessageFields.KEY_LINE_NR) != null) {
		position = parseInt(message.getProperty(com.inq.flash.client.data.MessageFields.KEY_LINE_NR));
	}

	com.inq.flash.client.chatskins.SkinControl.addAutomatonDataToChatWindow(
		displayText,
		position,
		null,
		message.getProperty(com.inq.flash.client.data.MessageFields.KEY_REPLAY),
		messageTimestamp);
};